<template>
  <ModalBase show-modal auto-h narrow @close-modal="close" class="gk-modal-copy-invoice">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
          {{ $gettext('COPY') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Invoice') }} {{ invoice.number }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div v-if="addNewProject">
        <h3>{{ $gettext('Add new customer or project') }}</h3>
        <AddProjectSimple ref="addeditproject" @created="customerProjectCreated" />
      </div>
      <div v-else>
        <p>{{ $gettext('Select a customer or project to copy this invoice to.') }}</p>
        <CustomerSelect @selected-customer="selectCustomerAndProject" @pre-selected-customer="selectCustomerAndProject" with-projects searchable :preselect="preselectedCustomer" />
        <p>
          <GekkoButton 
            @click="addNewProject = true"
            :text="$gettext('New project (or customer)? Create it first')" 
            variant="link"
            class="px-0 text-blue"
          />
        </p>
      </div>
    </template>
    <template v-if="addNewProject" v-slot:actions>
      <GekkoButton
        @click="addNewProject = false"
        :text="$gettext('Back')"
        variant="light"
      />
      <GekkoButton
        @click="$refs.addeditproject.saveForm()"
        :text="$gettext('Save')"
      />
    </template>
    <template v-else v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
      />
      <div class="premium-badge--inline">
        <GekkoButton
          @click="confirmCopy()"
          :disabled="!selectedCustomer"
          :text="$gettext('Copy')"
        >
          <template v-slot:premium-badge>
            <GkBadge 
              icon="fa-solid fa-crown"
              icon-only
              type="premium"
              variant="light-ghost"
            />
          </template>
        </GekkoButton>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import AddProjectSimple from "@/components/contacts/AddProjectSimple"
import CustomerSelect from "@/components/invoices/ui/CustomerSelect"

export default {
  name: 'InvoiceCopyModal',
  components: { ModalBase, TitleBar, GekkoButton, AddProjectSimple, CustomerSelect },
  props: {
    invoice: {
      type: Object,
      default: () => {}
    },
    useStore: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedCustomer: null,
      addNewProject: false
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
    }),
    preselectedCustomer () {
      const preselect = { name: '', customer_id: null, project_id: null }
      if (this.invoice.recipient_customer) {
        preselect.customer_id = this.invoice.recipient_customer.id
        preselect.name = this.invoice.recipient_customer.name
      }
      if (this.invoice.project) {
        preselect.project_id = this.invoice.project.id
        preselect.name = this.invoice.project.name
      }
      return preselect
    }
  },
  methods: {
    ...mapActions({ 
      setInvoiceToCopy: "invoices/setInvoiceToCopy",
      copyToCustomer: "invoices/copyToCustomer",
    }),
    close () {
      this.$emit('close')
      if (this.useStore) {
        this.setInvoiceToCopy(null)
      }
    },
    selectCustomerAndProject (selected) {
      if (selected.customer_id) {
        this.selectedCustomer = selected
      } else {
        this.selectedCustomer = null
      }
    },
    customerProjectCreated (data) {
      if (data.id && data.company) {
        this.selectedCustomer = { customer_id: data.company, project_id: data.id }
      }
      else{
        this.selectedCustomer = { customer_id: data.id, project_id: null }
      }
      this.confirmCopy()
    },
    confirmCopy () {
      if (this.currentCompany.is_premium) {
        if (this.selectedCustomer) {
          if (this.useStore) {
            this.copyToCustomer(this.selectedCustomer).then((response) => {
              this.$store.commit('invoices/REFRESH_INVOICE_LIST')
              this.$router.push({ name: 'InvoiceEdit', params: { invoiceId: response.data.id } })
            })
          } else {
            this.$emit('selected-customer', this.selectedCustomer)
          }
        }
      } else {
        this.$store.commit('togglePremiumModal', 'web_invoices_copy')
        this.close()
      }
    }
  }
}
</script>

<style lang="scss">
.gk-modal-copy-invoice {
  .gk-modal {
    max-width: 530px !important;
    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>